import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Users from "@/views/users/index.vue";
import UsersArea from "@/views/users/area.vue";
import NotAvailableArea from "@/views/users/not_available_area.vue";
import UnuseableAreaComplete from "@/views/users/unuseable_area_user/complete.vue";
import UsersNew from "@/views/users/new.vue";
import UsersSignUp from "@/views/users/sign_up.vue";
import UsersSendEmail from "@/views/users/send_email.vue";
import UsersWaitConfirmed from "@/views/users/wait_confirmed.vue";
import UsersConfirm from "@/views/users/confirm.vue";
import UsersReConfirmation from "@/views/users/reconfirmation.vue";
import UsersError from "@/views/users/error.vue";
import Shop from "@/views/shop/index.vue";
import Farm from "@/views/farm/index.vue";
import FarmHome from "@/views/farm/home.vue";
import Driver from "@/views/driver/index.vue";
import DeliveryLabel from "@/views/driver/label/index.vue";
import FarmLogin from "@/views/farm/login.vue";
import FarmSignup from "@/views/farm/signup.vue";
import FarmDashboard from "@/views/farm/dashboard.vue";
import FarmHarvest from "@/views/farm/harvests/index.vue";
import FarmHarvestDetail from "@/views/farm/harvests/detail.vue";
import FarmOrderItems from "@/views/farm/order_items/index.vue";
import FarmOrderItem from "@/views/farm/order_items/order_item.vue";
import FarmPdfs from "@/views/farm/pdfs/index.vue";
import FarmShippingResults from "@/views/farm/shipping_results/index.vue";
import FarmShippingResult from "@/views/farm/shipping_results/shipping_result.vue";
import FarmReceipt from "@/views/farm/shipping_results/pdf.vue";
import FarmConversation from "@/views/farm/conversations/index.vue";
import FarmConversationsDetail from "@/views/farm/conversations/detail.vue";
import FarmPdfPicker from "@/views/farm/pdf_picker.vue";
import FarmFlowers from "@/views/farm/flowers/index.vue";
import FarmFlowerDetail from "@/views/farm/flowers/detail.vue";
import FarmAccountSetting from "@/views/farm/account_setting.vue";
import FarmFarmSetting from "@/views/farm/farm_setting.vue";
import ShopLayout from "@/views/shop/layout.vue";
import ShopPdfPicker from "@/views/shop/pdf_picker.vue";
import ShopLogin from "@/views/shop/login.vue";
import ShopSignup from "@/views/shop/signup.vue";
import ShopProducts from "@/views/shop/products/index.vue";
import ShopProductsDetail from "@/views/shop/products/detail.vue";
import ShopFlowerSpecieIndex from "@/views/shop/flower_species/index.vue";
import ShopFlowerGenusIndex from "@/views/shop/flower_genus/index.vue";
import ShopOrders from "@/views/shop/orders/index.vue";
import ShopConversations from "@/views/shop/conversations/index.vue";
import ShopConversationsDetail from "@/views/shop/conversations/detail.vue";
import ShopCollections from "@/views/shop/collections/index.vue";
import ShopCollectionsDetail from "@/views/shop/collections/detail.vue";
import ShopCart from "@/views/shop/cart/index.vue";
import ShopCartConfirmation from "@/views/shop/cart/confirmation.vue";
import ShopCartComplete from "@/views/shop/cart/complete.vue";
import ShopSettingsShop from "@/views/shop/settings/shop.vue";
import ShopSettingsAccount from "@/views/shop/settings/account.vue";
import ShopSettingsShippingAddress from "@/views/shop/settings/shipping_address.vue";
import DriverLogin from "@/views/driver/login.vue";
import DriverHome from "@/views/driver/home.vue";
import DriverInformation from "@/views/driver/information/index.vue";
import DriverSettingsDriver from "@/views/driver/settings/driver.vue";
import DriverSettingsAccount from "@/views/driver/settings/account.vue";
import Admin from "@/views/admin/index.vue";
import AdminLogin from "@/views/admin/login.vue";
import Maintenance from "@/views/Maintenance.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  { name: "maintenance", path: "/maintenance", component: Maintenance },
  { name: "home", path: "/", component: Home },
  {
    path: "/users",
    component: Users,
    children: [
      { name: "usersArea", path: "area", component: UsersArea },
      { name: "notAvailableArea", path: "not_available_area", component: NotAvailableArea },
      { name: "unuseableAreaComplete", path: "not_available_area/complete", component: UnuseableAreaComplete },
      { name: "usersNew", path: "new", component: UsersNew },
      { name: "usersSignUp", path: "sign_up", component: UsersSignUp },
      { name: "usersSendEmail", path: "send_email", component: UsersSendEmail },
      { name: "usersWaitConfirmed", path: "wait_confirmed", component: UsersWaitConfirmed },
      { name: "usersConfirm", path: "confirm", component: UsersConfirm, props: true },
      { name: "usersReConfirmation", path: "reconfirmation", component: UsersReConfirmation },
      { name: "usersError", path: "error", component: UsersError }
    ]
  },
  {
    path: "/shop",
    component: Shop,
    children: [
      {
        name: "Shop",
        path: "",
        redirect: "products",
        component: ShopLayout,
        children: [
          { name: "shopProducts", path: "products", component: ShopProducts },
          { name: "shopProductsDetail", path: "products/:productId", component: ShopProductsDetail },
          { name: "shopFlowerSpecieIndex", path: "flower_species", component: ShopFlowerSpecieIndex },
          { name: "shopFlowerGenusIndex", path: "flower_genus", component: ShopFlowerGenusIndex },
          { name: "shopOrders", path: "orders", component: ShopOrders },
          { name: "shopConversations", path: "conversations", component: ShopConversations },
          { name: "shopConversationsDetail", path: "conversations/:conversationId", component: ShopConversationsDetail },
          { name: "shopCollections", path: "collections", component: ShopCollections },
          { name: "shopCollectionsDetail", path: "collections/:collectionId", component: ShopCollectionsDetail },
          { name: "shopCart", path: "cart", component: ShopCart },
          { name: "shopCartConfirmation", path: "cart/confirmation", component: ShopCartConfirmation },
          { name: "shopCartComplete", path: "cart/complete", component: ShopCartComplete },
          { name: "shopSettings", path: "settings", redirect: "settings/shop" },
          { name: "shopSettingsShop", path: "settings/shop", component: ShopSettingsShop },
          { name: "shopSettingsAccount", path: "settings/account", component: ShopSettingsAccount },
          { name: "shopSettingsShippingAddress", path: "settings/shipping_address", component: ShopSettingsShippingAddress },
          { name: "shopPdfPicker", path: "pdf_picker", component: ShopPdfPicker }
        ]
      },
      { name: "shopLogin", path: "login", component: ShopLogin },
      { name: "shopSignup", path: "signup", component: ShopSignup },
      { name: "shopNotFound", path: "*", component: ShopLayout }
    ]
  },
  {
    path: "/farm",
    component: Farm,
    children: [
      {
        name: "Farm",
        path: "",
        component: FarmHome,
        redirect: "/farm/dashboard",
        children: [
          { name: "farmDashboard", path: "dashboard", component: FarmDashboard },
          { name: "farmHarvest", path: "harvest", component: FarmHarvest },
          { name: "farmHarvestDetail", path: "harvest/:flowerGenusId", component: FarmHarvestDetail },
          { name: "farmOrderItems", path: "order_items", component: FarmOrderItems },
          { name: "farmOrderItem", path: "order_items/:id", component: FarmOrderItem },
          { name: "farmPdfs", path: "pdfs", component: FarmPdfs },
          { name: "farmConversations", path: "conversations", component: FarmConversation },
          { name: "farmConversationsDetail", path: "conversations/:conversationId", component: FarmConversationsDetail },
          { name: "farmFlowers", path: "flowers", component: FarmFlowers },
          { name: "farmFlowerDetail", path: "flower_detail/:flower_id?", component: FarmFlowerDetail },
          { name: "farmAccountSetting", path: "setting/account", component: FarmAccountSetting },
          { name: "farmFarmSetting", path: "setting/farm", component: FarmFarmSetting },
          { name: "farmPdfPicker", path: "pdf_picker", component: FarmPdfPicker },
          { name: "farmShippingResults", path: "shipping_results", component: FarmShippingResults },
          { name: "farmShippingResult", path: "shipping_result", component: FarmShippingResult }
        ]
      },
      { name: "farmLogin", path: "login", component: FarmLogin },
      { name: "farmSignup", path: "signup", component: FarmSignup },
      { name: "farmNotFound", path: "*", component: FarmHome }
    ]
  },
  {
    path: "/driver",
    component: Driver,
    children: [
      {
        path: "",
        component: DriverHome,
        children: [
          { path: "", redirect: "/driver/information" },
          { name: "driverInformation", path: "information", component: DriverInformation },
          { name: "driverSettings", path: "settings", redirect: "settings/driver" },
          { name: "driverSettingsDriver", path: "settings/driver", component: DriverSettingsDriver },
          { name: "driverSettingsAccount", path: "settings/account", component: DriverSettingsAccount }
        ]
      },
      { name: "deliveryLogin", path: "login", component: DriverLogin }
    ]
  },
  { name: "FarmReceipt", path: "/farmReceipt", component: FarmReceipt },
  { name: "DeliveryLabel", path: "/driver/label", component: DeliveryLabel },
  {
    path: "/admin",
    component: Admin,
    children: [{ name: "adminLogin", path: "login", component: AdminLogin }]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
